export default "__VITE_ASSET__VGQK3M52__"